import React from 'react';

const NosValeursHeader = () => {
  const headerStyle = {
    backgroundColor: '#ffffff',
    color: '#19214f',
    padding: '20px',
    textAlign: 'center',
    maxWidth: '800px', // Limite la largeur
    margin: '0 auto', // Centre le composant horizontalement
    boxSizing: 'border-box', // Gère le padding dans la largeur
    overflow: 'hidden',

  };

  const titleStyle = {
    fontSize: '2.5rem',
    margin: '0',
    fontWeight: 'bold',
  };

  const textStyle = {
    fontSize: '1.2rem',
    marginTop: '10px',
    lineHeight: '1.5',
  };

  return (
    <header style={headerStyle}>
      <h1 style={titleStyle}>Nos valeurs</h1>
      <p style={textStyle}>
        Les voiries franciliennes reposent sur trois valeurs essentielles qui guident chacune de nos actions et décisions.
      </p>
    </header>
  );
};

export default NosValeursHeader;
